import * as React from "react";
import { withStyles } from "@material-ui/core";
import connect from "react-redux/es/connect/connect";
import Button from "@material-ui/core/Button/Button";
import PropTypes from "prop-types";
import { DisclosureModal } from "../../containers/Cy/components";

const styles = (theme) => {
  return {
    seeImportantDisclosuresLinkContainer: {
      position: "absolute",
      width: "100%",
      bottom: 0,
      textAlign: "center",
    },
    finePrint: {
      fontSize: 12,
      textAlign: "left",
    },
    seeImportantDisclosuresLink: {
      fontSize: 12,
      textAlign: "center",
      cursor: "pointer",
      textTransform: "none",
      "@media print": {
        display: "none",
      },
    },
  };
};

class SeeImportantDisclosures extends React.Component {
  render() {
    const { classes, style, finePrint } = this.props;
    return (
      <div
        className={classes.seeImportantDisclosuresLinkContainer}
        style={style}
      >
        {finePrint && <p className={classes.finePrint}>{finePrint}</p>}
        <DisclosureModal
          dialogAnchorComponent={
            <Button
              className={classes.seeImportantDisclosuresLink}
              disableFocusRipple={true}
              disableRipple={true}
            >
              See Important Disclosures
            </Button>
          }
        />
      </div>
    );
  }
}

SeeImportantDisclosures.propTypes = {
  style: PropTypes.object,
  finePrint: PropTypes.string,
};

const mapStateToProps = (state, ownProps) => {
  return {};
};

export default withStyles(styles, { withTheme: true })(
  connect(mapStateToProps)(SeeImportantDisclosures)
);



// WEBPACK FOOTER //
// ./src/components/UI/SeeImportantDisclosures.jsx